import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { ErrorService } from './error.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  baseUrl = environment.socketApiURL;

  constructor(private httpClient: HttpClient,
              private errorService: ErrorService) { }

  list(model: any): Observable<any> {
    return this.httpClient
      .post<any>(`${this.baseUrl}country_list`, model)
      .pipe(
        catchError(this.errorService.handleError),
        map((res) => res)
      );
  }

}
